import React from 'react';
import { MonitorIcon, CodeIcon, ServerIcon, ArrowRightIcon, SearchIcon } from 'lucide-react';
import { NordenMascot } from './NordenMascot';
export function ServicesSection() {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="diensten" className="relative py-24 lg:py-28 bg-white overflow-hidden" data-id="element-971" data-mp="2lb9avh26p1qf">
      {/* Norden with laptop & gear — at work */}
      <div className="absolute -bottom-4 -left-4 lg:left-4 opacity-[0.08] pointer-events-none hidden md:block" data-id="element-972" data-mp="2bc1vypfswz17">
        <NordenMascot variant="laptop" size="xl" data-id="element-973" data-mp="1xlevarqhcz2h" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-974" data-mp="22i5e3mto68rl">
        <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 text-center mb-4" data-id="element-975" data-mp="1nlo0eoy0ci1v">
          Professioneel webdesign voor Alkmaarse ondernemers
        </h2>
        <p className="text-lg text-slate-600 text-center max-w-2xl mx-auto mb-12 lg:mb-16" data-id="element-976" data-mp="1sk908n9ckzps">
          Van strategie tot uitvoering. Wij zorgen voor een website die werkt.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-977" data-mp="2knewhcddh28l">
          <a href="#/website-laten-maken" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-978" data-mp="2yo9803vpvjbh">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-979" data-mp="26xbhn6gtoat6">
              <MonitorIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-980" data-mp="2fq571wpzgqkr" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-981" data-mp="2awafk744z7b4">
              Website laten maken
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-982" data-mp="1j77a4o0ijqww">
              Een professionele website laten maken in Alkmaar? Wij bouwen
              conversiegerichte websites die vertrouwen uitstralen en bezoekers
              omzetten in klanten.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-983" data-mp="3n990haj333vr">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-984" data-mp="vqxxkiy8f82" />
            </span>
          </a>

          <a href="#/seo-voor-websites" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-985" data-mp="2zdd1drm43sse">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-986" data-mp="39ahn5qc1pm8o">
              <SearchIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-987" data-mp="ollb6376k5su" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-988" data-mp="tildc30wsoeo">
              SEO voor websites
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-989" data-mp="2e49z94yzcpoc">
              Hoger scoren in Google en meer organisch verkeer? Wij
              optimaliseren jouw website voor zoekmachines met een bewezen SEO
              strategie.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-990" data-mp="1ze2qxi2osn1d">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-991" data-mp="1ubvb2heqkmtr" />
            </span>
          </a>

          <a href="#/wordpress-websites" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-992" data-mp="1qepgam2ttsf2">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-993" data-mp="3fratbcodk4vp">
              <CodeIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-994" data-mp="3aqn32t7yzs2j" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-995" data-mp="2ch5cum4c3wp6">
              WordPress websites
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-996" data-mp="1yfsxocwzzz4c">
              Op zoek naar een WordPress website in Alkmaar? Wij bouwen snelle,
              veilige WordPress sites met SEO-optimalisatie en eenvoudig
              contentbeheer.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-997" data-mp="1thre7qvntxsc">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-998" data-mp="1frxq5arzbhjo" />
            </span>
          </a>

          <a href="#/hosting-onderhoud" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-999" data-mp="1kq8zlked3q1d">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-1000" data-mp="1ate0p0e6fnmk">
              <ServerIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-1001" data-mp="n5h6eqgmarqu" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-1002" data-mp="111b74m78masv">
              Hosting & onderhoud
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1003" data-mp="1a43z6ro8uqjr">
              Snelle, veilige hosting en zorgeloos technisch onderhoud. Wij
              houden jouw website up-to-date zodat jij je kunt focussen op
              ondernemen.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-1004" data-mp="1jtdoy0vm7x4p">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-1005" data-mp="1trjsemx2lbbo" />
            </span>
          </a>
        </div>

        <div className="mt-12 text-center" data-id="element-1006" data-mp="1ou1fymjugdyx">
          <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-semibold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-base group" data-id="element-1007" data-mp="1ov30dhmr2ctb">
            Vraag een vrijblijvend gesprek aan
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" data-id="element-1008" data-mp="2almaydy81x11" />
          </a>
        </div>
      </div>
    </section>;
}